import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Header from "./Header"


function Logout( data ) {
  const navigate = useNavigate()

  data.logout()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      navigate('/')
    }, 3000);

    return () => {
      clearTimeout( timeoutId )
    }
  }, [ navigate ])

  return (
    <div className="pageWrapper">
      <Header headerContext='logout'/>
      <div className='logoutContentHolder'>
          <div className="logoutText">
              <h3 className="logoutIcon">👋</h3>
              <h3>You've been logged out</h3>
          </div>
      </div>
    </div>

  );
}

export default Logout
